import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";

export default function NotRegisterModel({ setModal }) {
  const path = "Assets/scss/postproject.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  return (
    <div>
      <button onClick={() => setModal(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Welcome to Urexpert</h4>
        <p>
          To proceed with posting, please login to your account or register if
          you don't have one yet.
        </p>
      </ModalBody>
      <div className="modal-footer" style={{ display: "flex" , flexWrap:'nowrap',columnGap:'30px' }}>
        <button
          className="btn"
          onClick={() => {
            setModal((state) => !state);
            navigate(`/${lan}/loginwithemail`);
          }}
        >
          Login
        </button>
        <button
          className="btn"
          onClick={() => {
            setModal((state) => !state);
            navigate(`/${lan}/signup`);
          }}
        >
          Register
        </button>
      </div>
    </div>
  );
}
